(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabDevicesDetailController', TabDevicesDetailController);

    TabDevicesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'TabDevices', 'TabDevicesTypes', 'TabObjectTypes', 'TabSchedule'];

    function TabDevicesDetailController($scope, $rootScope, $stateParams, entity, TabDevices, TabDevicesTypes, TabObjectTypes, TabSchedule) {
        var vm = this;
        vm.tabDevices = entity;

        var unsubscribe = $rootScope.$on('jotApp:tabDevicesUpdate', function(event, result) {
            vm.tabDevices = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
